import { Draft } from "immer";

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductCrossReferenceLookupState } from "@tIntermatic/Store/Data/ProductCrossReferenceLookup/ProductCrossReferenceLookupState";
import { CrossReferenceLookupModel } from "@tIntermatic/Types/CrossReferenceLookupModel";

const initialGiftMessageState: ProductCrossReferenceLookupState = {
    isLoading: false,
    value: undefined,
};

const reducer = {
    "Data/Products/BeginLoadCrossReferenceLookUp": (draft: Draft<ProductCrossReferenceLookupState>) => {
        draft.isLoading = true;
    },

    "Data/Products/CompleteLoadCrossReferenceLookUp": (
        draft: Draft<ProductCrossReferenceLookupState>,
        action: { result: CrossReferenceLookupModel },
    ) => {
        draft.isLoading = false;
        draft.value = action.result;
    },
};

export default createTypedReducerWithImmer(initialGiftMessageState, reducer);
